import React from "react";
import { useTranslation } from "react-i18next";
import { IMAGE_SPECS, ImageSpecKey } from "../../utils/imageSpecs";
import ImageValidationInfo from "./ImageValidationInfo";
import styles from "./ImageSpecsBadges.module.css";

interface ImageSpecsBadgesProps {
    spec: ImageSpecKey;
    className?: string;
    /** Soft validation warnings after upload / for existing image (no dimensions line) */
    warnings?: string[];
}

const ImageSpecsBadges: React.FC<ImageSpecsBadgesProps> = ({ spec, className, warnings = [] }) => {
    const { t: rawT } = useTranslation();
    const t = rawT as any;
    const displaySpec = IMAGE_SPECS[spec];

    return (
        <div className={`${styles.container}${className ? ` ${className}` : ""}`}>
            <div className={styles.specsContainer}>
                {displaySpec.ratioLabel && (
                    <span className={styles.specBadge}>
                        {t("avatarRatio")} : {displaySpec.ratioLabel}
                    </span>
                )}
                <span className={styles.specBadge}>
                    {t("avatarWeight")} : {t(displaySpec.maxWeightKey)} max.
                </span>
            </div>
            <ImageValidationInfo warnings={warnings} />
        </div>
    );
};

export default ImageSpecsBadges;
